import { Noner } from '../components'

export const NotFound = () => {
  return (
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
      <Noner none="404 not found" />
    </div>
  )
}
